const font36 = {
  fontSize: '36px',
  lineHeight: '56px',
  letterSpacing: '0px',
};

const font28 = {
  fontSize: '28px',
  lineHeight: '44px',
  letterSpacing: '0px',
};

const font24 = {
  fontSize: '24px',
  lineHeight: '38px',
  letterSpacing: '0px',
};

const font20 = {
  fontSize: '20px',
  lineHeight: '32px',
  letterSpacing: '0px',
};

const font16 = {
  fontSize: '16px',
  lineHeight: '1.3',
  letterSpacing: '0px',
};

const font18 = {
  fontSize: '18px',
  lineHeight: '28px',
  letterSpacing: '0px',
};

const font14 = {
  fontSize: '14px',
  lineHeight: '1.4',
  letterSpacing: '0px',
};

const font12 = {
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0px',
};

export const FONTS = {
  font36,
  font28,
  font24,
  font20,
  font18,
  font16,
  font14,
  font12,
};

const FontLight = {
  fontFamily: 'Roboto',
  fontWeight: '300',
  fontStyle: 'normal',
};

const FontRegular = {
  fontFamily: 'Roboto',
  fontWeight: '400',
  fontStyle: 'normal',
};

const FontMedium = {
  fontFamily: 'Roboto',
  fontWeight: '500',
  fontStyle: 'normal',
};

const FontSemiBold = {
  fontFamily: 'Roboto',
  fontWeight: '600',
  fontStyle: 'normal',
};

const FontBold = {
  fontFamily: 'Roboto',
  fontWeight: '700',
  fontStyle: 'normal',
};

const FontExtraBold = {
  fontFamily: 'Roboto ',
  fontWeight: '800',
  fontStyle: 'normal',
};

const FontBlack = {
  fontFamily: 'Roboto ',
  fontWeight: '900',
  fontStyle: 'normal',
};

export const FONT_FAMILY = {
  FontLight,
  FontRegular,
  FontMedium,
  FontSemiBold,
  FontBold,
  FontExtraBold,
  FontBlack,
};
